var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0",attrs:{"id":"cts-nt"}},[(_vm.number)?_c('span',{staticClass:"cts-nt-number pr-2 mr-3"},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_c('span',{staticClass:"cts-nt-title"},[_vm._v(_vm._s(_vm.text))]),(_vm.required)?_c('span',{staticClass:"cts-nt-required ml-2"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }